import { render, staticRenderFns } from "./LiveComments.vue?vue&type=template&id=2abf3cf5&scoped=true"
import script from "./LiveComments.vue?vue&type=script&lang=ts"
export * from "./LiveComments.vue?vue&type=script&lang=ts"
import style0 from "./LiveComments.vue?vue&type=style&index=0&id=2abf3cf5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf3cf5",
  null
  
)

export default component.exports